export default __webpack_public_path__ + "assets/images/solutions/bd6b31d30d7eea128b1dd834f5b4277a.mp4";